import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useEffect, useId, useState } from 'react';
import { LstTipoConta } from '../../../../../interfaces/entities/Reembolso/DadosContaBeneficiario';
import { AccountTypeFilterProps } from '../../../../../interfaces/props/Financeiro/Reembolso/AccountsFiltersProps';
import './styles.css';
import { sxFilterSelect, sxMenuItem } from './sxProps';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { InputLabel } from '@mui/material';


function AccountTypeFilter(props: AccountTypeFilterProps) {
    const [value, setValue] = useState<string>('');
    const [options, setOptions] = useState<LstTipoConta[]>([]);

    const uniqueId = useId();
    const accessibility = useAccessibility();

    useEffect(() => {
        setOptions(props.options)
        if (props.value) {
            setValue(props.value);
        }
    }, [props.options])

    useEffect(() => {
        if (props.erase !== undefined) {
            setValue(props.value || '');
        }
    }, [props.erase])

    useEffect(() => {
        setValue(props.value || '');
    }, [props.value])


    const handleChange = (event: SelectChangeEvent) => {
        setValue(event.target.value)
        props.handleChange(event.target.value);
    };

    return (
        <div className={`select-holder`}>
            <label style={accessibility.textStyleAccessibility} className='select-label'>{props.title}</label>
            <InputLabel
                id={`${uniqueId}-label`}
                style={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                margin: '-1px',
                padding: '0',
                border: '0',
                overflow: 'hidden',
                clip: 'rect(0 0 0 0)',
                whiteSpace: 'nowrap',
                }}
            >
                {props.title}
            </InputLabel>
            <Select
                labelId={`${uniqueId}-label`}
                id={uniqueId}
                value={value}
                onChange={handleChange}
                fullWidth
                sx={sxFilterSelect}
                IconComponent={(props) => <FontAwesomeIcon icon={faChevronDown} {...props} color={'#383838'} />}
                displayEmpty
                renderValue={
                    value !== "" ? () => options.find((option) => option.indTipoConta === value)?.descricao : () => <span className='placeholder'>Selecione</span>
                }
                disabled={props.disabled}
            >
                {options.map((option) => (
                    <MenuItem key={`filter-${option.indTipoConta}`} value={option.indTipoConta} sx={sxMenuItem}>{option.descricao}</MenuItem>
                ))}
            </Select>
        </div>
    );
}

export default AccountTypeFilter;